var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "absolute inset-0 z-10 bg-white rounded-xl"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-4"
  }, _vm._l(_vm.mainCards, function (card) {
    return _c('div', {
      key: card.title,
      staticClass: "bg-white border border-gray-200 rounded-2xl p-6"
    }, [_c('img', {
      staticClass: "w-8 h-8 mb-4",
      attrs: {
        "src": card.icon,
        "alt": ""
      }
    }), _c('p', {
      staticClass: "text-base text-gray-500 mb-1"
    }, [_vm._v(_vm._s(card.title))]), _c('h3', {
      staticClass: "text-2xl font-bold text-gray-900 mb-0"
    }, [_vm._v(_vm._s(card.value))])]);
  }), 0), _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-4"
  }, _vm._l(_vm.metricGroups, function (group, index) {
    return _c('div', {
      key: index,
      staticClass: "relative overflow-hidden bg-white border border-gray-200 rounded-2xl p-6"
    }, [_c('div', {
      staticClass: "relative grid grid-cols-3 gap-4"
    }, _vm._l(group, function (metric) {
      return _c('div', {
        key: metric.title
      }, [_c('div', {
        staticClass: "flex items-center justify-center w-8 h-8 mb-4 rounded-lg bg-gray-100 text-gray-700"
      }, [_c('i', {
        class: metric.icon
      })]), _c('p', {
        staticClass: "text-base text-gray-500 mb-1"
      }, [_vm._v(_vm._s(metric.title))]), _c('h3', {
        staticClass: "text-2xl font-bold text-gray-900 mb-0"
      }, [_vm._v(_vm._s(_vm.formatNumber(metric.value)))])]);
    }), 0)]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }